import { DocumentBlank } from '@carbon/react/icons';
import { getError } from 'atoms/form-atoms';
import searchAtomPair from 'atoms/search-atom';
import { Column, ComboBox, Row, Layer } from '@carbon/react';
import { FormRow, FormSection } from 'components/forms';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { debounce } from 'lodash-es';
import { useMemo } from 'react';
import { CountyQueryResponse } from 'types/api-responses';
import { formAtom } from './atoms';

const { searchAtom, resetSearchDataAtom } =
  searchAtomPair<CountyQueryResponse>('counties');

const County = () => {
  const form = useAtomValue(formAtom);
  const [county, setCounty] = useAtom(form.countyId);
  const [query, setPayload] = useAtom(searchAtom);
  const resetSearchData = useSetAtom(resetSearchDataAtom);
  const debouncedSetPayload = useMemo(
    () => debounce(setPayload, 400),
    [setPayload]
  );
  return (
    <FormSection
      title="General Document Info"
      iconComponent={<DocumentBlank size={32} />}
    >
      <FormRow>
        <Row>
          <Column>
            <Layer>
              <ComboBox
                id={`county`}
                titleText="County"
                items={query?.data?.results || []}
                placeholder=""
                itemToString={(data) => {
                  return data ? `${data.name}, ${data.stateAbbreviation}` : '';
                }}
                itemToElement={(result) => (
                  <>{`${result.name}, ${result.stateAbbreviation}`}</>
                )}
                selectedItem={county.value || null}
                onChange={({ selectedItem }) => {
                  if (selectedItem) setCounty(selectedItem ?? null);
                }}
                onInputChange={(text) => {
                  resetSearchData(undefined);
                  debouncedSetPayload((current) => ({
                    ...current,
                    text,
                    pageSize: 10,
                  }));
                }}
                invalid={!county.isValid}
                invalidText={getError(county)}
              />
            </Layer>
          </Column>
        </Row>
      </FormRow>
    </FormSection>
  );
};

export { County };
